import { COMMUNE_OK, COMMUNE_ERR } from "./commune.action";

const InitState = {
  error: null,
  content: null,
};

export default function CommuneReducer(state = InitState, action) {
  switch (action.type) {
    case COMMUNE_OK: {
      return {
        ...state,
        error: null,
        content: action.payload.content,
      };
    }
    case COMMUNE_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: null,
      };
    }
    default:
      return state;
  }
}
